import { create } from "zustand";

// Global UI selection state — which customer/agent the user is currently
// focused on. Kept in Zustand rather than URL params for now so cross-
// page panels (chat pane, connect button, right-rail) don't have to
// thread props everywhere. When we add deep-linkable URLs (phase 2)
// the store becomes a reflection of the URL rather than the source of
// truth; until then this is simpler.
//
// Server state (customer list, org chart, agents) lives in React Query —
// do NOT add API data here. This store is only for client-only state.

interface SelectionState {
  customerId: string | null;
  agentTemplate: string | null;
  setCustomer: (id: string | null) => void;
  setAgent: (template: string | null) => void;
  clear: () => void;
}

export const useSelection = create<SelectionState>((set) => ({
  customerId: null,
  agentTemplate: null,
  setCustomer: (id) =>
    set((s) => ({
      customerId: id,
      // Clear agent if customer changes — prevents stale (customer A, agent
      // from customer B) combos that would 404 on the chat route.
      agentTemplate: id === s.customerId ? s.agentTemplate : null,
    })),
  setAgent: (template) => set({ agentTemplate: template }),
  clear: () => set({ customerId: null, agentTemplate: null }),
}));
